import {NfMessage, NfMessageType} from "../NfMessage";
import type {NavigationPageName, NavigationPages} from "../../../frontendClasses/NavigationPages";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import {isUndefined} from "lodash-es";
import {getNavigationNameFromPage} from "../../../frontendClasses/NavigationPages";

/**
 * Wiadomość globalna, gdy nawigacja została zakończona
 */
export class Navigated extends NfComponentGlobalMessage {
    declare public navigationPage: NavigationPages;
    declare public navigationPageName: NavigationPageName;
    public navigationData: any;

    /**
     *
     * @param navigationPage
     * @param navigationData Uwaga, navigationData musi być serializowalne, dopuszczalne jest wysyłanie momentów i podstawowych typów danych
     */
    public constructor(navigationPage: NavigationPages|MessageEvent<Navigated>, navigationData?: any) {
        super(NfMessageType.Navigated, !NfMessage.isMessageEvent(navigationPage));
        if(NfMessage.isMessageEvent(navigationPage)) {
            Object.assign(this, navigationPage.data);
        } else {
            if(isUndefined(navigationPage) || navigationPage === null) {
                throw Error('navigationPage jest wymagany');
            }
            this.navigationPage = navigationPage;

            this.navigationPageName = getNavigationNameFromPage(navigationPage);

            this.navigationData = this.serialize(navigationData);
        }
    }

    public getNavigationData() {
        return this.deserialize(this.navigationData);
    }
}
NfMessage.creationCallbacks[NfMessageType.Navigated] = (event) => {
    return new Navigated(event);
}
